import storage from "../../services/storage";
import initialState from "../initialState";
import { InitialState, LOGIN_SUCCESS, AuthAction, USER_LOGOUT } from "../types";

const authReducer = (
  state = initialState.authState,
  action: AuthAction
): InitialState["authState"] => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      storage.set("address", action.payload.user.publicaddress);
      storage.set("token", action.payload.token);
      storage.set("publicKey", action.payload.user.publicKey);
      return {
        ...state,
        token: action.payload.token,
        address: action.payload.user.publicaddress,
        publicKey: action.payload.user.publicKey,
      };
    }
    case USER_LOGOUT: {
      storage.remove("address");
      storage.remove("token");
      return {
        ...state,
        token: null,
        address: null,
      };
    }
    default:
      return state;
  }
};

export default authReducer;
